import { useNavigate } from 'react-router-dom';
import { ScopedCssBaseline, ThemeProvider } from '@mui/material';
import { brightpathTheme } from '@youscience/theme';
import { CoreBox } from '@youscience/core';

import { ROUTES } from '@constants/ROUTES';
import { PLAN_FOR_COLLEGE_CARDS } from '@constants/nonLearnerHomePage';
import { BREADCRUMBS_PAGE_TEXT } from '@constants/breadcrumbs';

import baseHomeImage from '@images/base-home-page.jpg';

import HeroSection from '../HeroSection';
import EducationOpportunities from '../EducationOpportunities';
import PlanForCollege from '../PlanForCollege';
import AreasOfStudySection from '../AreasOfStudySection';

export const NonLearnerHomePage = () => {
  const navigate = useNavigate();

  return (
    <ThemeProvider theme={brightpathTheme}>
      <ScopedCssBaseline />

      <HeroSection
        title={BREADCRUMBS_PAGE_TEXT.ROOT}
        subtitle="Explore postsecondary education options to help build your skills, earn a degree, and reach your career goals."
        button1Name="Start exploring"
        onButton1Click={() => navigate(ROUTES.SCHOOLS)}
        image={baseHomeImage}
      />

      <CoreBox sx={{ backgroundColor: '#F9F9F9' }}>
        <PlanForCollege cards={PLAN_FOR_COLLEGE_CARDS} />

        <EducationOpportunities />

        <AreasOfStudySection />
      </CoreBox>
    </ThemeProvider>
  );
};
